import React, { useMemo, VoidFunctionComponent } from 'react';
import { StarFill } from "@/components/responsive/product/icons/StarFill";
import { StarHalf } from "@/components/responsive/product/icons/StarHalf";
import { StarEmpty } from "@/components/responsive/product/icons/StarEmpty";
import { MAX_RATING } from '@/utils/constants';

interface Props {
    score: string,
    color?: string,
    id?: string;
}

export const DisplayStars: VoidFunctionComponent<Props> = (props) => {
    let { score, color } = props;
    const scoreNumber = Math.round(parseFloat(score) * 10) / 10;
    const rest = scoreNumber % 1;
    const LIMIT_TO_FILL_START = 0.5;


    const stars = useMemo(() => {
        let starsArray = [];

        for (let i = 0; i < MAX_RATING; i++) {
            if (i < Math.floor(scoreNumber) || (i === Math.floor(scoreNumber) && rest > LIMIT_TO_FILL_START)) {
                starsArray.push(<StarFill color={color} key={i + `starFill`} />);
            } else if (i === Math.floor(scoreNumber) && rest === LIMIT_TO_FILL_START) {
                starsArray.push(<StarHalf color={color} key={i + `starHalf`} />);
            } else {
                starsArray.push(<StarEmpty color={color} key={i + `emptyStar`} />);
            }
        }
        return starsArray
    }, [score, color])
    return <>
        {stars}
    </>;
}
